import AuthContext from 'adal-angular'

const config = {
    tenant: 'birdconstruction.onmicrosoft.com',
    clientId: "020f56f3-2ebc-4b58-84e8-2a9d0eb4d676", //CanemAuth
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin + '/signout.html',  
    cacheLocation: 'localStorage'
  };
  
  export default {
    authContext: null,
    /**
     * @return {Promise}
     */
    initialize() {
      this.authContext = new AuthContext(config);
  
      return new Promise((resolve, reject) => {
        if (this.authContext.isCallback(window.location.hash) || window.self !== window.top) {
          // redirect to the location specified in the url params.
          this.authContext.handleWindowCallback();
        }
        else {
          // try pull the user & token out of local storage
          let user = this.authContext.getCachedUser();
          let token = this.authContext.getCachedToken(this.authContext.config.clientId);
  
          if (user && !token) {
            token = this.authContext.acquireToken(this.authContext.config.clientId)
        }
          if (user && token) {
            resolve();
          }
          else {
            reject(new Error("Auth - No User"));
            // no user at all - go sign in.
            this.signIn();
          }
        }
      });
    }, 
    /**
     * @return {Promise.<String>} A promise that resolves to an ADAL token for resource access
     */
    acquireToken() {
      return new Promise((resolve, reject) => {
        this.authContext.acquireToken(this.authContext.config.clientId, (error, token) => {
          if (error || !token) {
            return reject(error);
          } else {
            return resolve(token);
          }
        });
      });
    },
    acquireGraphToken(){
      return new Promise((resolve, reject) => {
        this.authContext.acquireToken("https://graph.microsoft.com", (error, token) => {
          if (error || !token) {
            return reject(error);
          } else {
            return resolve(token);
          }
        });
      });     
    },
    /**
     * Issue an interactive authentication request for the current user and the api resource.
     */
    acquireTokenRedirect() {
      this.authContext.acquireTokenRedirect(this.authContext.config.clientId);
    },
    /**
     * @return {Boolean} Indicates if there is a valid, non-expired access token present in localStorage.
     */
    isAuthenticated() {
      // getCachedToken will only return a valid, non-expired token.
      if (this.authContext.getCachedToken(config.clientId)) { return true; }
      return false;
    },
    /**
     * @return An ADAL user profile object.
     */
    getUserProfile() {
      return this.authContext.getCachedUser().profile;
    },
    signIn() {
      this.authContext.login();
    },
    signOut() {
      this.authContext.logOut();
    },
    name() {
      return this.authContext.getCachedUser().profile.name;
    },
    firstname() {
      return this.authContext.getCachedUser().profile.given_name;
    },
    userid() {
      var profile = this.getUserProfile();
      return profile.upn.slice(0, profile.upn.indexOf("@")); //canem userId
    }
  }
  
  